import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type ElementKey = 'element1' | 'element2' | 'element3'
type TypeKey = 'absolute' | 'dynamic'

const SteeringRangesTooltipContent = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)

  return (
    <Box>
      <Box>{page === 1 ? <FirstPage /> : <SecondPage />}</Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, px: 1 }}>
        {page === 2 && (
          <Button startIcon={<ArrowBackIcon />} sx={{ color: 'white' }} onClick={() => setPage(1)}>
            {t('common.button.previous')}
          </Button>
        )}
        {page === 1 && (
          <Button endIcon={<ArrowForwardIcon />} sx={{ color: 'white', ml: 'auto' }} onClick={() => setPage(2)}>
            {t('common.button.next')}
          </Button>
        )}
      </Box>
    </Box>
  )
}

function FirstPage() {
  const { t } = useTranslation()

  const elements: ElementKey[] = ['element1', 'element2', 'element3']
  const types: TypeKey[] = ['absolute', 'dynamic']

  return (
    <>
      <Typography sx={{ color: 'white' }} variant="body2">
        {t('resources.steering.steering_ranges.tooltip.description')}
      </Typography>
      <List dense disablePadding>
        {elements.map((elem) => (
          <ListItem key={elem} disableGutters>
            <ListItemText
              primary={t(`resources.steering.steering_ranges.tooltip.${elem}`)}
              primaryTypographyProps={{ color: 'white', fontWeight: 'bold' }}
            />
          </ListItem>
        ))}
      </List>
      <Typography sx={{ color: 'white', mt: 2 }} variant="body2">
        {t('resources.steering.steering_ranges.tooltip.value_types')}
      </Typography>
      <List dense disablePadding>
        {types.map((type) => (
          <ListItem key={type} disableGutters>
            <ListItemText
              primary={t(`resources.steering.steering_ranges.tooltip.${type}`)}
              primaryTypographyProps={{ color: 'white', fontWeight: 'bold' }}
              secondary={t(`resources.steering.steering_ranges.tooltip.${type}_description`)}
              secondaryTypographyProps={{ color: 'white' }}
            />
          </ListItem>
        ))}
      </List>
    </>
  )
}

function SecondPage() {
  const { t } = useTranslation()

  return (
    <>
      <Typography sx={{ color: 'white' }} variant="body2">
        {t('resources.steering.steering_ranges.tooltip.time_constraints')}
      </Typography>
      <Typography sx={{ color: 'white', mt: 1 }} variant="body2">
        {t('resources.steering.steering_ranges.tooltip.step_explanation')}
      </Typography>
    </>
  )
}

export default SteeringRangesTooltipContent
